import React from "react";
import "./styles/confirmationModal.css"
class ConfirmationModal extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
            <div onClick={this.props.handleCloseModal} className="ConfirmationModalContainer">
                <div onClick={(e)=>{e.stopPropagation()}} className="ConfirmationModalWrapper">
                    <div className="ConfirmationModal__header">
                        <span className="ConfirmationModal__title">{this.props.header}</span>
                        <span onClick={this.props.handleCloseModal} className="ConfirmationModal_close">x</span>
                    </div>
                    <div className="ConfirmationModal__body">
                        {this.props.message}
                    </div>
                    <div className="ConfirmationModal__footer">
                    <button className="ConfirmationModal__button" onClick={this.props.handleOnClickMethod}> Confirmar</button>
                    </div>
                </div>
            </div>
        );
    }
}
export default ConfirmationModal;